/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claim_Custom_DomainInputs */

const en_claim_custom_domain = /** @type {(inputs: Claim_Custom_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claim Custom Domain`)
};

const es_claim_custom_domain = /** @type {(inputs: Claim_Custom_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reclamar dominio personalizado`)
};

const fr_claim_custom_domain = /** @type {(inputs: Claim_Custom_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réclamer un domaine personnalisé`)
};

const de_claim_custom_domain = /** @type {(inputs: Claim_Custom_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eigene Domain beanspruchen`)
};

const ja_claim_custom_domain = /** @type {(inputs: Claim_Custom_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カスタムドメインを取得する`)
};

const zh_claim_custom_domain = /** @type {(inputs: Claim_Custom_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`申请自定义域名`)
};

const ar_claim_custom_domain = /** @type {(inputs: Claim_Custom_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`احصل على نطاق مخصص`)
};

const id_claim_custom_domain = /** @type {(inputs: Claim_Custom_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klaim Domain Kustom`)
};

const it_claim_custom_domain = /** @type {(inputs: Claim_Custom_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Richiedi Dominio Personalizzato`)
};

const ru_claim_custom_domain = /** @type {(inputs: Claim_Custom_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запросить собственный домен`)
};

const pt_claim_custom_domain = /** @type {(inputs: Claim_Custom_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reivindicar Domínio Personalizado`)
};

const ko_claim_custom_domain = /** @type {(inputs: Claim_Custom_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`맞춤형 도메인 신청`)
};

/**
* | output |
* | --- |
* | "Claim Custom Domain" |
*
* @param {Claim_Custom_DomainInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const claim_custom_domain = /** @type {((inputs?: Claim_Custom_DomainInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claim_Custom_DomainInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_claim_custom_domain(inputs)
	if (locale === "es") return es_claim_custom_domain(inputs)
	if (locale === "fr") return fr_claim_custom_domain(inputs)
	if (locale === "de") return de_claim_custom_domain(inputs)
	if (locale === "ja") return ja_claim_custom_domain(inputs)
	if (locale === "zh") return zh_claim_custom_domain(inputs)
	if (locale === "ar") return ar_claim_custom_domain(inputs)
	if (locale === "id") return id_claim_custom_domain(inputs)
	if (locale === "it") return it_claim_custom_domain(inputs)
	if (locale === "ru") return ru_claim_custom_domain(inputs)
	if (locale === "pt") return pt_claim_custom_domain(inputs)
	return ko_claim_custom_domain(inputs)
});